import { CheckExternalLink } from 'hook/useCheckExternalLink/useCheckExternalLink';

export const handleNavigate = async (
  data,
  navigate,
  setNotifyId,
  refetch,
  productId,
  location,
  mutateExternalLink,
  productData,
) => {
  if (data?.destinationType === 'DETAILS_AVAILABLE') {
    if (location?.includes('list-notify')) {
      if (productId) {
        navigate(
          `/top-page/top-page-product/list-notify/${productId}/notify-detail/${data?.notifyId}`,
        );
      } else {
        navigate(`/top-page/list-notify/notify-detail/${data?.notifyId}`);
      }
    } else {
      if (productId) {
        navigate(
          `/top-page/top-page-product/${productId}/notify-detail/${data?.notifyId}`,
        );
      } else {
        navigate(`/top-page/notify-detail/${data?.notifyId}`);
      }
    }
  }

  if (
    (data?.url && data?.destinationType === 'EXTERNAL_LINKS') ||
    data?.destinationType === 'INTERNAL_LINKS'
  ) {
    const payload = {
      externalUrl: data?.url,
      productId: Number(productId) ?? productData?.product?.productId,
      productName: productData?.product?.productName,
    };

    if (CheckExternalLink(data?.url) && mutateExternalLink) {
      mutateExternalLink(payload);
    }
    if (data?.isNewTab) {
      window.open(data?.url, '_blank');
    } else {
      const isExternal = CheckExternalLink(data?.url);
      if (isExternal) {
        window.open(data?.url, '_self');
      } else {
        const urlObject = new URL(data?.url);
        let internalPath = urlObject?.hash.replace('#', '');
        navigate(internalPath);
      }
    }
  }

  if (data?.destinationType === 'PDF') {
    if (data?.saveName) {
      await setNotifyId(data?.notifyId);
      await refetch().then((value) => {
        window.open(value?.data, '_self');
      });
    }
  }
};
